import { useEffect } from "react";

const SITE_URL = "https://www.miscanthus-sarthe.fr";
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/Re_colte-3.webp`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

/**
 * Définit les balises SEO de la page : title, meta description,
 * canonical et Open Graph. `path` doit commencer par "/" (ex: "/produits").
 */
export function useSEO({ title, description, path, ogImage }) {
  useEffect(() => {
    const url = `${SITE_URL}${path === "/" ? "/" : path}`;
    document.title = title;
    setMeta("name", "description", description);
    setCanonical(url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", ogImage || DEFAULT_OG_IMAGE);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "fr_FR");
    setMeta("property", "og:site_name", "EARL Torcé Biomasse Energie — Miscanthus Sarthe");
  }, [title, description, path, ogImage]);
}

/**
 * Injecte un bloc JSON-LD (données structurées schema.org) dans le <head>,
 * retiré au démontage de la page. `data` peut être null tant que les
 * données ne sont pas chargées.
 */
export function useJsonLd(id, data) {
  const json = data ? JSON.stringify(data) : null;
  useEffect(() => {
    if (!json) return undefined;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = json;
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, json]);
}
